__turbopack_context__.v({
  "menu": "qTPtHW_menu",
  "overlay": "qTPtHW_overlay",
});
